var map = {
	"./888.png": 300,
	"./BCT168.png": 301,
	"./KPW.png": 302,
	"./LMHSB168.png": 303,
	"./MHSB168.png": 304,
	"./MHSB999.png": 305,
	"./MHSBC.png": 306,
	"./MHSBGREEN.png": 307,
	"./ONLINEP99.png": 308,
	"./P99.png": 309,
	"./SBS636.png": 310,
	"./cards/no-price/kp/EIGHT.png": 311,
	"./cards/no-price/kp/ELEVEN.png": 312,
	"./cards/no-price/kp/FIVE.png": 313,
	"./cards/no-price/kp/FOUR.png": 314,
	"./cards/no-price/kp/NINE.png": 315,
	"./cards/no-price/kp/ONE.png": 316,
	"./cards/no-price/kp/SEVEN.png": 317,
	"./cards/no-price/kp/SIX.png": 318,
	"./cards/no-price/kp/TEN.png": 319,
	"./cards/no-price/kp/THREE.png": 320,
	"./cards/no-price/kp/TWELVE.png": 321,
	"./cards/no-price/kp/TWO.png": 322,
	"./cards/no-price/normal/v1/EIGHT.png": 323,
	"./cards/no-price/normal/v1/ELEVEN.png": 324,
	"./cards/no-price/normal/v1/FIVE.png": 325,
	"./cards/no-price/normal/v1/FOUR.png": 326,
	"./cards/no-price/normal/v1/NINE.png": 327,
	"./cards/no-price/normal/v1/ONE.png": 328,
	"./cards/no-price/normal/v1/SEVEN.png": 329,
	"./cards/no-price/normal/v1/SIX.png": 330,
	"./cards/no-price/normal/v1/TEN.png": 331,
	"./cards/no-price/normal/v1/THREE.png": 332,
	"./cards/no-price/normal/v1/TWELVE.png": 333,
	"./cards/no-price/normal/v1/TWO.png": 334,
	"./cards/no-price/normal/v2/EIGHT.png": 335,
	"./cards/no-price/normal/v2/ELEVEN.png": 336,
	"./cards/no-price/normal/v2/FIVE.png": 337,
	"./cards/no-price/normal/v2/FOUR.png": 338,
	"./cards/no-price/normal/v2/NINE.png": 339,
	"./cards/no-price/normal/v2/ONE.png": 340,
	"./cards/no-price/normal/v2/SEVEN.png": 341,
	"./cards/no-price/normal/v2/SIX.png": 342,
	"./cards/no-price/normal/v2/TEN.png": 343,
	"./cards/no-price/normal/v2/THREE.png": 344,
	"./cards/no-price/normal/v2/TWELVE.png": 345,
	"./cards/no-price/normal/v2/TWO.png": 346,
	"./cards/no-price/normal/v3/EIGHT.png": 347,
	"./cards/no-price/normal/v3/ELEVEN.png": 348,
	"./cards/no-price/normal/v3/FIVE.png": 349,
	"./cards/no-price/normal/v3/FOUR.png": 350,
	"./cards/no-price/normal/v3/NINE.png": 351,
	"./cards/no-price/normal/v3/ONE.png": 352,
	"./cards/no-price/normal/v3/SEVEN.png": 353,
	"./cards/no-price/normal/v3/SIX.png": 354,
	"./cards/no-price/normal/v3/TEN.png": 355,
	"./cards/no-price/normal/v3/THREE.png": 356,
	"./cards/no-price/normal/v3/TWELVE.png": 357,
	"./cards/no-price/normal/v3/TWO.png": 358,
	"./slots/BLUE.png": 359,
	"./slots/GREEN.png": 360,
	"./slots/ODD.png": 361,
	"./slots/OVER.png": 362,
	"./slots/UNDER.png": 363,
	"./slots/no-price/BLUE.png": 364,
	"./slots/no-price/EVEN.png": 365,
	"./slots/no-price/GREEN.png": 366,
	"./slots/no-price/ODD.png": 367,
	"./slots/no-price/OVER.png": 368,
	"./slots/no-price/RED.png": 369,
	"./slots/no-price/UNDER.png": 370
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79;